const LandingPage = () => {
  return (
    <>
      <main className="landing-background">
        <div className="landing-content">
          <div className="text-center">
            <h2 className="fw-bold">Insta Compare</h2>
            <hr />
            <p className="">Web-App to compare your instagram follower</p>
            <p className="launching-soon">
              Building in-progress, check{" "}
              <span>
                <a href="https://github.com/akashprasher/insta-compare">
                  Github
                </a>
              </span>
            </p>
          </div>
        </div>
      </main>
    </>
  );
};

export default LandingPage;
